// tslint:disable-next-line:no-reference
/// <reference path="types/globals.d.ts" />
// tslint:disable-next-line:no-reference
/// <reference path="../typings/index.d.ts" />
// tslint:disable-next-line:no-reference
/// <reference path="index.d.ts" />

import { urls$ } from 'utils/UrlListener';
import { appServices } from './singletons';
import { history } from './wlHistory';
import { Translator } from 'Translator';
import { path2GACategory } from 'utils/analytics';
import Analytics from '@withlocals/withlocals-analytics';
import { WlWindow } from 'typings/globals/cordova';

const availableLanguages = require('resources/languages.json');
declare const window: WlWindow;

export default () => {
  if (window.analBuffer) {
    window.analBuffer.push = (...events) => {
      events.forEach(event => Analytics.pushBitterbal(event));
    };
    window.analBuffer.forEach(event => Analytics.pushBitterbal(event));
  }


  console.log('Main started');

  if (typeof window?.IntersectionObserver === 'undefined') {
    require('intersection-observer');
  }

  appServices.permissionFunctions.startPush();

  const trackPage = (pathName) => {
    const path = pathName.split('/').filter(x => !!x);
    if (availableLanguages.indexOf(path[0]) > -1) {
      path.splice(0, 1);
    }
    const pageCategory = path2GACategory(pathName);
    const authCategories = ['Log in', 'Sign up'];
    if (authCategories.includes(pageCategory) && !authCategories.includes(window.currentPageCategory)) {
      window.previousNonAuthPageCategory = window.currentPageCategory;
    }
    window.currentPageCategory = pageCategory;

    Analytics.page(path.join('/'), { pathName, pageCategory, title: window.document.title, lang: Translator.getLanguageCode() });
  };

  // handle old (hash-based) urls
  urls$
    .subscribe((pathName) => {
      const { location } = window;
      trackPage(pathName);
      if (pathName === '/' && location.hash.length > 0) {
        history.replace(location.hash.substr(1));
      }
    });
  
  return 'loaded';
};
